import head from 'lodash/head'

const pad0 = (p: number) => p < 10 ? `0${p}` : `${p}`

const humanizeSeconds = (seconds: number) => {
  const m = Math.floor(seconds / 60)
  const s = seconds % 60

  const mStr = m > 0 ? `${m} ${m === 1 ? 'minute' : 'minutes'}` : ''
  const sStr = `${s} ${s === 1 ? 'second' : 'seconds'}`

  return `${mStr} ${sStr}`.trim()
}

const humanizeMinutes = (seconds: number) => {
  const m = Math.floor(seconds / 60)
  const s = seconds % 60

  return `${m}:${pad0(s)} minutes`
}

const formatFileSize = (size: number) => !size ? '0.000' : (size / 1000 / 1000).toFixed(3)
const truncate = (str: string, len: number) => str.length > len
  ? `${str.substring(0, len - 2)}..`
  : str

const formatFileName = (name: string | undefined, size?: number) => {
  if (name && (size || size === 0)){
    const truncatedName = truncate(name.replace(/\.[^/.]+$/, ''), 15)
    const fileName = head(/(?:\.([^.]+))?$/.exec(name))
    const fileSize = formatFileSize(size)
    return `${truncatedName}${fileName} (${fileSize} MB)`
  }
  if (name) {
    const truncatedName = truncate(name.replace(/\.[^/.]+$/, ''), 15)
    const fileName = head(/(?:\.([^.]+))?$/.exec(name))
    return `${truncatedName}${fileName}`
  }
  if (size || size === 0) return `${formatFileSize(size)} MB`
  return null
}

export {
  formatFileName,
  formatFileSize,
  humanizeMinutes,
  humanizeSeconds,
  truncate
}
